<template>
  <v-container class="zoom">
    <!-- fecha -->
    <v-row align="center">
      <v-col><v-divider></v-divider></v-col>
      <v-col class="text-center">
        <!-- <v-btn @click.stop="$emit('goday', infoFecha)" outlined x-small> -->
        <v-btn :ripple="false" outlined x-small>
          {{ txtFecha }}
          <!-- <v-icon right x-small>call_made</v-icon> -->
        </v-btn>
      </v-col>
      <v-col><v-divider></v-divider></v-col>
    </v-row>

    <!-- vdm -->
    <v-row v-if="userNote && userNote.vdm">
      <v-col class="pb-0">
        <span class="overline font-weight-bold" :class="colorText">
          {{ t.cuaderno.vdlm }}
        </span>
        <p class="vdm">{{ userNote.vdm }}</p>
      </v-col>
    </v-row>

    <!-- oracion personal -->
    <v-row v-if="userNote && userNote.ora">
      <v-col class="pb-0">
        <span class="overline font-weight-bold" :class="colorText">
          {{ t.cuaderno.tuOraPerson }}
        </span>
        <p>{{ userNote.ora }}</p>
      </v-col>
    </v-row>

    <!-- compromiso personal -->
    <v-row v-if="userNote && userNote.com">
      <v-col>
        <span class="overline font-weight-bold" :class="colorText">
          {{ t.cuaderno.tuComprom }}
          <v-icon small>{{ iconoCompromiso }}</v-icon>
        </span>
        <p>{{ userNote.com }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mixUserConfig from "../../mixs/mixUserConfig.js";
import mixUserColor from "../../mixs/mixUserColor.js";

import infoo from "../../plugins/infoo";

export default {
  name: "mdd-cuaderno-resumen-dia",
  mixins: [mixUserConfig, mixUserColor],
  props: ["userNote", "diasDesdeHoy", "dia"],
  computed: {
    iconoCompromiso() {
      let i = ["", "close", "done", "done_all"];
      let idx = this.userNote.cok;
      return this.userNote ? i[idx] : "";
    },
    infoFecha() {
      let f = infoo.fechaIso(this.dia);
      return {
        anio: f.anio,
        mes: f.mes,
        dia: f.dia,
        iso: f.iso,
        nombreDia: this.t.dias[f.diaSem],
        nombreMes: this.t.meses[f.mes]
      };
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    },
    txtFecha() {
      if (this.diasDesdeHoy === 1) {
        return this.t.dias.ayer;
      } else if (this.diasDesdeHoy < 4) {
        return this.infoFecha.nombreDia;
      } else {
        return this.infoFecha.nombreMes + " " + this.infoFecha.dia;
      }
    }
  }
};
</script>
